// components/WarningModal.tsx
import React from "react";

interface WarningModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  message: any;
}

const WarningModal: React.FC<WarningModalProps> = ({ show, handleClose, title, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black opacity-90 z-50">
      <div className="bg-green-500 w-full max-w-md rounded-lg shadow-lg">

        {/* Modal Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button onClick={handleClose} className="text-gray-500 hover:text-gray-700">&times;</button>
        </div>

        {/* Modal Body */}
        <div className="p-4">
          <p>{message}</p>
        </div>

        {/* Modal Footer */}
        <div className="flex justify-end p-4 border-t">
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded mr-2 hover:bg-gray-400">
            I understand
          </button>

        </div>

      </div>
    </div>
  );
};

export default WarningModal;
